// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__27Kaq","topBottomGutter":"Layout_topBottomGutter__PsKbk"};